import cx from 'classnames';

import { Container } from '@/components/Default/Container';
import { Link } from '@/components/Default/Link';
import { Image } from '@/components/Default/Image';

import { Theme } from './API/Theme';

interface TinybarProps {
    open: boolean;
    onOpen: () => void;
    theme: Theme;
    distance: number;
}

const Tinybar = ({ open, onOpen, theme, distance }: TinybarProps) => {
    const height = (typeof window !== 'undefined' && window.innerHeight) || 0;
    const hasTraveled = distance > height;

    const imageSrc = theme === 'light' || hasTraveled
        ? 'https://timeforsolar-assets.s3.eu-west-2.amazonaws.com/logo-letterform-02.svg'  // Black Text
        : 'https://timeforsolar-assets.s3.eu-west-2.amazonaws.com/logo-letterform-06.svg';   // White Text

    return (
        <nav className={cx(
            'top-0 z-[39] w-full flex justify-between 2xl:hidden px-4 sm:px-8',
            'transition-opacity duration-500 opacity-0', {
                'opacity-100 absolute py-8 flex justify-between items-center pointer-events-none': ! hasTraveled,
                'opacity-100 fixed top-0 py-4 z-[39] w-full bg-white shadow-sm border-b': hasTraveled
            }
        )}>
            <Link href='/' className='py-2 pointer-events-auto shrink-0' aria-label='Naar de hoofdpagina'>
                <Image src={imageSrc} width={300} height={61.3} alt='' className='w-40 sm:w-64 sm:h-auto' />
            </Link>
            <div className={cx('py-2 sm:py-4 cursor-pointer pointer-events-auto flex 2xl:hidden items-center transition-none', {
                'text-white bg-black px-2 sm:px-4': ! hasTraveled,
                'text-black px-4': hasTraveled
            })} onClick={onOpen}>
                <Container render={() => {
                    if (open) {
                        return (
                            <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6 sm:w-8 sm:h-8'>
                                <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
                            </svg>
                        );
                    }

                    return (
                        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6 sm:w-8 sm:h-8'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5' />
                        </svg>
                    );
                }} />
            </div>
        </nav>
    );
};

export { Tinybar };